import axios from 'axios';

export function logoutUser() {
  return axios.post('/api/logout', { data: {} });
}

export function setOnboardingStatus(type: string) {
  return axios.post('/setOnboardingStatus', {
    type,
  });
}
